import React, { useContext, useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { useTranslation, Trans } from "react-i18next";
import Stack from 'react-bootstrap/Stack';
import { isNumberKey, isZeroOne, isNumber2Decimals, numericKeydown } from './../../utils';
import { NumericFormat } from 'react-number-format';
import { action } from "mobx";

const FormText = (props) => {
    const { t, i18n } = useTranslation();
    const [value, setValue] = useState("");
    const [touched, setTouched] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {

        var originalValue = (props.object ? (props.object)?.[props.id] : props.value)
        var val = (originalValue || (props.allowDefault ? originalValue : ""));

        if (props.useFormattedInput) {
            updateValue(val);
        } else {

            if (!val && props?.valueIfNull) { val = props.valueIfNull }
            if (props.only2Decimals) { val = Number(val).toFixed(2) }
            if (props.formatInitBlur) { val = props.formatInitBlur(val) }

            updateValue(val);
        }

    }, [props.object]);


    useEffect(() => {
        if (props.clearOn)
            setValue("")

    }, [props.clearOn])

    const updateValue = (val) => {
        if (props.useFormattedInput) {
            setValue(val);                       
        }
        else {
            if (val?.length && props.maxLength)
                val = val?.slice(0, props.maxLength);

            if (props.lines) {
                var currentLines = (val?.toString().match(/\n/g) || []).length;
                if (currentLines >= props.lines)
                    return;
            }

            var formattedVal = props?.formatter ? props?.formatter(val) : val;

            setValue(formattedVal);
            validate(formattedVal);

            if (props.onChange && touched)
                props.onChange(formattedVal);
        }

        setTouched(true);
    }

    const validate = (val) => {
        var isValid = props.validator ? props?.validator(val) : true
        inputRef?.current?.setCustomValidity(!isValid ? "Invalid format" : "")
    }

    const getFormatter = (e) => {
        if (props.onlyDigits) {
            return props.onlyZeroOne ? isZeroOne : isNumberKey
        }
        else if (props.only2Decimals)
            return isNumber2Decimals;
        else
            return null;
    }
    return (
        <Form.Group controlId={props.id} style={{ display: props.hidden ? "none" : "" }}>
            {props.isLoading ? <Skeleton /> : props.label ? <Form.Label>
                <Stack direction="horizontal" gap={1}>
                    {props.label}
                    {props.recentlyChanged && <div title={t("recentlyChanged")} style={{ fontSize: 6, }}>{"\uD83D\uDD34"}</div>}
                </Stack>
            </Form.Label> : null}
            {props.isLoading ? <Skeleton height={30} /> :
                (props.useFormattedInput ?
                           
                    <NumericFormat                            
                        id={props.id}
                        style={{ textAlign: "right", height: props.lines ? "80px" : "auto" }}
                        disabled={props.disabled}
                        required={props.required}
                        lines={props.lines || 1}
                        name={props.id}
                        className="form-control"
                        placeholder={props.placeholder ? props.placeholder : t("enterValue")}

                        value={value ?? ''}
                        onValueChange={action((values, sourceInfo) => {
                            updateValue(values?.floatValue ?? "");
                        })}

                        valueIsNumericString={true}
                        fixedDecimalScale
                        decimalScale={props.decimalScale ?? undefined}
                        allowLeadingZeros={false}
                        thousandSeparator="'"
                        decimalSeparator="."
                        onKeyDown={(e) => {                                                     
                            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                var step = props.step == null || props.step === "any" ? 1 : Number(props.step);

                                switch (e.key) {
                                    case "ArrowDown":
                                        updateValue(value - step);
                                        break;
                                    case "ArrowUp":
                                        updateValue(value + step);
                                        break;
                                    default:
                                        break;
                                }                                                                
                            }
                        }}

                        />                                            
                    :

                    <Form.Control
                        autoFocus={props.autoFocus ?? false}
                        ref={inputRef}
                        style={{ height: props.lines ? "80px" : "auto" }}
                        as={props.lines ? "textarea" : "input"}
                        lines={props.lines || 1}
                        step={props.step ?? null}
                        disabled={props.disabled}
                        required={props.required}

                        name={props.id}
                        type={props.type || "text"}
                        placeholder={props.placeholder ? props.placeholder : t("enterValue")}
                        value={value}
                        onChange={(e) => { updateValue(e.target.value) }}
                        onFocus={() => {
                            if (props.clearOnFocus) { setValue("") }
                        }}
                        onKeyPress={getFormatter()}
                        onBlur={e => {
                            if (props?.formatInitBlur)
                                updateValue(props.formatInitBlur(e.target.value))
                        }}

                        onKeyDown={(e) => {
                            switch (props.keydownFormat) {
                                case "timesheet":
                                    numericKeydown(e, () => updateValue(""))
                                    break;
                                default:
                                    break;
                            }

                        }}
                    />)
            }
            <Form.Control.Feedback type="invalid">
                {t('fieldRequired')}
            </Form.Control.Feedback>

        </Form.Group>
    );
};

export default observer(FormText);
